import React, { MouseEvent } from "react";
import { components, MultiValueProps } from "react-select";
import { SortableElement } from "react-sortable-hoc";

const SortableSelectItem = SortableElement((props: MultiValueProps) => {
    const onMouseDown = (evt: MouseEvent) => {
        evt.preventDefault();
        evt.stopPropagation();
    };
    const innerProps = { onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
});

export default SortableSelectItem;
